import React, { useState, useRef } from 'react';
import prompts from 'shared/lib/prompts';
import classNames from 'classnames';
import useOutsideClick from 'shared/lib/useOutsideClick';

const ShortPrompts = ({ onSelect, disabled }) => {

  const list = prompts();
  const [subs, setSubs] = useState(null);

  const handleSelect = (prompt) => {
    setSubs(null);

    if (prompt) onSelect(prompt);
  }

  const renderItem = (item) => {
    const { name, icon, title, actions, prompt } = item;

    const subListRef = useOutsideClick(() => setSubs(null));

    const promptBtnHandler = () => {
      prompt ? handleSelect(prompt) : setSubs(item);
    };

    return (
      <button key={name} onClick={promptBtnHandler} className="s-copywriter-short-prompts__item">
        <i className={`fi fi-${icon}`} />
        <span className="s-copywriter-short-prompts__btn-text">{title}</span>
        {(subs && subs.name === name) && <div ref={subListRef} className="s-copywriter-short-prompts__sub-list">{subs.actions.map(renderSubItem)}</div>}
      </button>
    );
  };

  const renderSubItem = (item) => {
    const { name, icon, title, actions, prompt } = item;

    if (!actions || actions.length === 0) return renderPrompt(item);

    return (
      <div key={name} className="s-copywriter-short-prompts__sub-item">
        <div className="s-copywriter-short-prompts__sub-item-title">{title}</div>
        <div className="s-copywriter-short-prompts__prompts">{actions.map(renderPrompt)}</div>
      </div>
    );
  };

  const renderPrompt = ({ name, title, prompt, icon }) => {
    return (
      <div key={name} onClick={() => handleSelect(prompt)} className="s-copywriter-short-prompts__prompt">
        {icon && <span className="s-copywriter-short-prompts__prompt-icon">{icon}</span>}
        <span>{title}</span>
      </div>
    );
  }

  const classes = classNames("s-copywriter-short-prompts", {
    "s-copywriter-short-prompts--disabled": disabled
  });

  return <div className={classes}>
    <div className="s-copywriter-short-prompts__list">
      {list.map(renderItem)}
    </div>
  </div>;
}

export default ShortPrompts;
